import React, { useId, useState } from 'react';
import { CollapsibleFilterSectionProps } from './types';

const CollapsibleFilterSection: React.FC<CollapsibleFilterSectionProps> = ({
  title,
  note,
  defaultExpanded = true,
  activeFilterCount = 0,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const bodyId = useId();

  return (
    <section className="filter-section">
      <button
        type="button"
        className="filter-section-header"
        aria-expanded={isExpanded}
        aria-controls={bodyId}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="filter-section-title">
          {title}
          {note && <span className="filter-section-note">{note}</span>}
        </span>
        <span className="filter-section-meta">
          {activeFilterCount > 0 && (
            <span className="filter-section-count" aria-label={`${activeFilterCount} active`}>{activeFilterCount}</span>
          )}
          <svg className="filter-section-chev" viewBox="0 0 16 16" aria-hidden="true" style={isExpanded ? undefined : { transform: 'rotate(-90deg)' }}>
            <path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      {isExpanded && (
        <div className="filter-section-content" id={bodyId}>
          {children}
        </div>
      )}
    </section>
  );
};

export default CollapsibleFilterSection;
